export interface DevicesDatabase {
  ios: Record<string, string[]>;
  android: Record<string, string[]>;
}

export const devicesDB: DevicesDatabase = {
  ios: {
    Apple: [
      "iPhone 15 / 15 Plus / 15 Pro / 15 Pro Max",
      "iPhone 14 / 14 Plus / 14 Pro / 14 Pro Max",
      "iPhone 13 / 13 Mini / 13 Pro / 13 Pro Max",
      "iPhone 12 / 12 Mini / 12 Pro / 12 Pro Max",
      "iPhone 11 / 11 Pro / 11 Pro Max",
      "iPhone XS / XS Max / XR",
      "iPhone SE (2020 / 2022)",
      "iPad Air (3rd / 4th / 5th Gen)",
      "iPad Pro (3rd Gen trở lên)",
      "iPad Mini (5th / 6th Gen)"
    ]
  },
  android: {
    Samsung: [
      "Galaxy S24 / S24+ / S24 Ultra",
      "Galaxy S23 / S23+ / S23 Ultra",
      "Galaxy S22 / S22+ / S22 Ultra",
      "Galaxy S21 / S21+ / S21 Ultra",
      "Galaxy S20 / S20+ / S20 Ultra",
      "Galaxy Z Fold 5 / 4 / 3 / 2",
      "Galaxy Z Flip 5 / 4 / 3",
      "Galaxy Note 20 / Note 20 Ultra"
    ],
    "Google Pixel": [
      "Pixel 8 / 8 Pro",
      "Pixel 7 / 7 Pro / 7a",
      "Pixel 6 / 6 Pro / 6a",
      "Pixel 5 / 5a",
      "Pixel 4 / 4XL / 4a"
    ],
    Huawei: ["P40 / P40 Pro", "Mate 40 Pro"],
    Oppo: ["Find X5 / X5 Pro", "Find X3 Pro", "Reno 6 Pro 5G"]
  }
}

export const countryMap: Record<string, string> = {
  VN: 'Vietnam',
  US: 'United States',
  CA: 'Canada',
  MX: 'Mexico',
  JP: 'Japan',
  KR: 'South Korea',
  SG: 'Singapore',
  TH: 'Thailand',
  FR: 'France',
  DE: 'Germany',
  IT: 'Italy',
}
